import Modal from 'components/Layout/Modal';
import React, { useState } from 'react';
import Button from 'components/form/Button';
import { useDispatch } from 'react-redux';
import Dropdown from 'components/form/Dropdown';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

const AddManualFollowUpPopup = ({ onHide, event_id, followUpsList }) => {
  const [isDeleteLoader, setIsDeleteLoader] = useState(false);
  const { eID } = useParams();
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    category: Yup.string().required('Category is required'),
  });

  const initialValues = {
    category: '',
  };

  const handleSubmit = (values) => {
    navigate(
      `/admin/follow-up-discount/${eID}/manual-follow-up/${values.category}/details`
    );
  };

  return (
    <Modal
      size="md"
      onHide={() => {
        onHide();
      }}
      titleBesideClose="Add Follow-up"
      titleBesideCloseClassName="cps-15"
      isTitleBorder
      isTitleVerticalCenter
    >
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, setFieldValue }) => (
          <Form>
            <div className="cpt-20 cpb-20 add-user-container">
              <div className="cmt-5 cps-32 cpe-60">
                <Dropdown
                  id="category"
                  label="Follow-Up Category *"
                  placeholder="Select Category"
                  options={followUpsList}
                  optionValue="label"
                  value={values.category}
                  error={touched.category && errors.category}
                  onChange={(e) => setFieldValue('category', e.target.value)}
                />
              </div>

              <div className="cmt-30 cps-32 cpe-32">
                <div className="d-flex align-items-center gap-3">
                  <Button
                    type="submit"
                    text="Next"
                    btnStyle="primary-dark"
                    className="h-35 cps-20 cpe-20"
                    btnLoading={isDeleteLoader}
                  />
                  <Button
                    text="Cancel"
                    btnStyle="light-outline"
                    className="h-35 cps-20 cpe-20"
                    onClick={() => {
                      onHide();
                    }}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default AddManualFollowUpPopup;
